import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import {
  registerUser,
  saveResults,
  checkUser,
  setPreRegistrationFlag,
  setUserIPAddress,
  setRegistrationInProgress,
} from '../../store/actions';
import {
  getPreRegistrationState,
  getAuthState,
  getOnboardingState,
  getUserCountry,
  getUserTerritory,
  getUserEmail,
} from '../../store/selectors';
import { fireGTM } from '../../gtm/gtmUtil';
import { registrationPage_GTM } from '../../gtm/datalayers/registrationDataLayers.json';
import { getIPAddress } from '../../util/userIPAddressUtil';
import Loading from '../utility/Loading';

// Register a Baobab user without their interaction

class PassiveRegistration extends React.Component {
  saveGameResults = async (token) => {
    const requestBody = {
      riasecValues: this.props.preregistration.score,
    };

    await this.props.saveResults(requestBody, token);
  };

  saveUserInfo = async (token) => {
    try {
      const requestBody = {
        email: this.props.userEmail,
        firstName: this.props.auth.user.attributes.given_name
          ? this.props.auth.user.attributes.given_name
          : ' ',
        lastName: this.props.auth.user.attributes.family_name
          ? this.props.auth.user.attributes.family_name
          : ' ',
        dateOfBirth: '1801-01-01',
        highSchool: '',
        graduationYear: this.props.preregistration.education.graduationYear,
        country: this.props.preregistration.country,
        state: this.props.preregistration.territory,
        educationLevel: this.props.preregistration.education.educationLevel,
        receiveCommunications: false,
        registrationSource: this.props.preregistration.registrationSource,
      };

      const registeredUserId = await this.props.registerUser(
        requestBody,
        token
      );
      // Get the user IP address
      const userIPAddress = await getIPAddress();

      if (!isEmpty(userIPAddress) && registeredUserId) {
        this.props.setUserIPAddress(registeredUserId, token, userIPAddress);
      }
      await this.saveGameResults(token);
    } catch (error) {
      console.log('Registration error: ', error);
    }
  };

  async componentDidMount() {
    const userId = await this.props.checkUser(this.props.userEmail);

    if (userId === 'NotFound') {
      await this.saveUserInfo(this.props.auth.jwtToken);

      this.props.setRegistrationInProgress(true);
      this.props.setPreRegistrationFlag(false);
      if (this.isAuthenticated) {
        await this.saveUserInfo(this.props.auth.jwtToken);
        await this.props.setUser(this.props.auth.user);
      }
      // Now tell GTM there was a succesful signup/registration
      fireGTM(registrationPage_GTM.continueSuccessful);
      this.props.setPreRegistrationFlag(true);
    } else {
      console.log('Registration error: User already exists');
    }
  }

  render() {
    return (
      <div className="passive-registration">
        <Loading height="100vh" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const preregistration = getPreRegistrationState(state);
  const auth = getAuthState(state);
  const userCountry = getUserCountry(state);
  const userTerritory = getUserTerritory(state);
  const userEmail = getUserEmail(state);

  return {
    onboarding,
    preregistration,
    auth,
    userCountry,
    userTerritory,
    userEmail,
  };
};

export default connect(mapStateToProps, {
  registerUser,
  saveResults,
  checkUser,
  setPreRegistrationFlag,
  setUserIPAddress,
  setRegistrationInProgress,
})(PassiveRegistration);
